// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2oHXR","inner":"Form_inner__2ibC4","range":"Form_range__3JUE5","name":"Form_name__3GbiD","actions":"Form_actions__2nN4q"};